import React from 'react';
import { arrayRailsTop as tooltip } from 'pu-data/Tooltips';
import TextComponent from './TextComponent';

const ArrayRailsRight = (props) => {
  const name = 'rails_top';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="Top rail"
      name={name}
      value={props.parameters[name] || ''}
      onChange={props.onChange || onChange}
      tooltip={tooltip}
      groupName={props.groupName} />
  );
};

ArrayRailsRight.defaultProps = {};

export default ArrayRailsRight;
